import axios from 'axios';
import config from '@config/index';

const baseURL = import.meta.env.PROD ? config.VITE_API_URL : undefined;

export const defaultAxiosInstance = axios.create({
  withCredentials: true,
  baseURL,
});
